import * as tslib_1 from "tslib";
import * as esriLoader from 'esri-loader';
var LayerExtender = /** @class */ (function () {
    function LayerExtender() {
    }
    LayerExtender.construct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, layer, MCMap;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, esriLoader.loadModules(['esri/layers/BaseDynamicLayer'], window.esriConfig)];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), layer = _a[0];
                        MCMap = /** @class */ (function (_super) {
                            tslib_1.__extends(class_1, _super);
                            function class_1(properties) {
                                var _this = _super.call(this, properties) || this;
                                if (properties) {
                                    _this.CategoryId = properties.CategoryId;
                                    _this.ColumnList = properties.ColumnList;
                                    _this.CreatedDate = properties.CreatedDate;
                                    _this.Description = properties.Description;
                                    _this.FeatureSearchPriority = properties.FeatureSearchPriority;
                                    _this.Filter = properties.Filter;
                                    _this.HoverColumnList = properties.HoverColumnList;
                                    _this.IsActive = properties.IsActive;
                                    _this.IsSystem = properties.IsSystem;
                                    _this.IsFeatureSearchable = properties.IsFeatureSearchable;
                                    _this.IsSearchable = properties.IsSearchable;
                                    _this.LastEditedDate = properties.LastEditedDate;
                                    _this.Name = properties.Name;
                                    _this.SearchPriority = properties.SearchPriority;
                                    _this.UniqueName = properties.UniqueName;
                                    _this.UserFilterObject = properties.UserFilterObject;
                                }
                                return _this;
                            }
                            return class_1;
                        }(layer));
                        return [2 /*return*/, MCMap];
                }
            });
        });
    };
    return LayerExtender;
}());
export { LayerExtender };
